import { CircularProgress } from '@material-ui/core';

export function Loading() {
    return <div style={{ margin: "20px", display:"flex", justifyContent:"center"}}><CircularProgress /></div>
}